'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isTrue = function isTrue(v) {
  return v && v.toLowerCase() === 'true';
};

var isSafeMode = exports.isSafeMode = function isSafeMode(options) {
  return options.safeMode || options.localStorage && isTrue(options.localStorage.getItem('HUB-HTTP_SAFE_MODE'));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.176/js/helpers/safeMode.js
// module id = 275
// module chunks = 0